var COLLECTOR_URL = 'https://collector.schibsted.io';
var COLLECTOR_PATH = 'api/v1/track';

export default {
  collectorUrl: COLLECTOR_URL,
  collectorPath: COLLECTOR_PATH,
  eventDebounce: 200,
  environment: 'browser',
  useBeaconWhenAvailable: true
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-sdk/dist/ejs/config-browser.js
// module id = 1239
// module chunks = 0